/* oxlint-disable max-lines */
import { IRegion } from '../../types/geo';
import {
  ECommuteDistanceType,
  EHeatingSourceType,
  EHouseMaterialType,
  ELocationType,
  EOtherCommunications,
  EReadyStatus,
  ESaleStatus,
  ESorting,
  EWcLocationType,
  IGetVillageListRequestSchema,
} from '../../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';

import { IRange } from '../../interfaces/filters';
import { createRegionSeoUrl } from '../../utils/seo';
import { ICity } from '../geo';
import { geoUpdateCityAction, TGeocodedForSearchFetched } from '../geo/actions';
import { fetchRegionCities } from '../geo/thunkActions';

import { IThunkActionCreator, ITypedReduxAction } from '../../types/store';
import { fetchMarkedList, fetchSeoData } from '../seo/actions';
import { fetchVillageList } from '../village_list/actions';
import { getSeoUrlPath, getUnknownQuery, isClient, mergeQuery } from '../../utils';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { fetchStarted } from '../is_fetching/actions';
import { stringifyFilters } from '../../utils/filters';

export type Action =
  | TFinishDateChanged
  | TNewObjectTypeChanged
  | TVillageClassChanged
  | TPriceRangeChanged
  | ECommuteDistanceTypeChanged
  | TCommuteDistanceChanged
  | TGeocodedForSearchFetched
  | TPageChanged
  | IFilterRegionChanged
  | IGetRegionByDomainFetched
  | TSaleStatusChanged
  | TReadyStatusChanged
  | TFloorCountFromChanged
  | TFloorCountToChanged
  | TAreaFromChanged
  | TAreaToChanged
  | TOtherCommunicationChanged
  | THouseMaterialChanged
  | IApplyLastFilters
  | TBuilderIdRemoved
  | TBuilderIdAdded
  | THeatingSourceTypeChanged
  | TWcLocationChanged
  | TRoadFilterAdded
  | TRoadFilterRemoved
  | TRoadDistanceChanged
  | TRemoveFilters
  | TRemoveLocationId
  | TResetExtraFilters
  | TStationsAdded
  | TStationsChanged
  | TStationDistanceChanged
  | TNewObjectTypesChanged
  | TVillageClassesChanged
  | TSaleStatusesChanged
  | EReadyStatusesChanged
  | THeatingSourceTypesChanged
  | THouseMaterialsChanged
  | TOtherCommunicationsChanged
  | TFiltersChanged
  | TBlackFridayChanged;

export interface IChangedFilterItem {
  value: string[];
}

export enum EFilterActions {
  AddBuilderId = 'BuilderIdAdded',
  AddRoads = 'RoadFilterAdded',
  AddStations = 'StationFilterAdded',
  ChangeHeatingSourceTypes = 'HeatingSourceTypesChanged',
  ChangeHeatingSourceType = 'IHeatingSourceTypeChanged',
  ChangeNewObjectTypes = 'FilterNewObjectTypesChanged',
  ChangeVillageClasses = 'FilterVillageClassesChanged',
  ChangeSaleStatuses = 'SaleStatusesChanged',
  ChangeReadyStatuses = 'ReadyStatusesChanged',
  ChangeHouseMaterials = 'HouseMaterialsChanged',
  ChangeOtherCommunications = 'OtherCommunicationsChanged',
  ChangeNewObjectType = 'FilterNewObjectTypeChanged',
  ChangeVillageClass = 'FilterVillageClassChanged',
  ChangeFinishDate = 'FilterFinishDateChanged',
  ChangePriceRange = 'FilterPriceRangeChanged',
  ChangeCommuteDistance = 'CommuteDistanceСhanged',
  ChangeCommuteType = 'CommuteDistanceType',
  RemoveLocationId = 'RemoveLocationId',
  RemoveFilters = 'RemoveFilters',
  RemoveBuilderId = 'BuilderIdRemoved',
  ResetExtraFilters = 'ResetExtraFilters',
  ChangeRoads = 'RoadFilterRemoved',
  ChangeStationDistance = 'StationDistanceChanged',
  ChangeStations = 'StationFilterRemoved',
  ChangeRoadDistance = 'RoadDistanceChanged',
  ChangeSaleStatus = 'ISaleStatusChanged',
  ChangeReadyStatus = 'IReadyStatusChanged',
  ChangeCommunication = 'IOtherCommunicationChanged',
  ChangeAreaFrom = 'IAreaFromChanged',
  ChangeAreaTo = 'IAreaToChanged',
  ChangeFloorCountFrom = 'IFloorCountFromChanged',
  ChangeFloorCountTo = 'IFloorCountToChanged',
  ChangeHouseMaterial = 'IHouseMaterialChanged',
  ChangeWcLocation = 'IWcLocationTypeChanged',
  ChangePage = 'IPageChange',
  ChangeFilters = 'IChangeFilters',
  ChangeBlackFridayFlag = 'IBlackFridayFlagChanged',
}

export type TFiltersChanged = ITypedReduxAction<EFilterActions.ChangeFilters, IGetVillageListRequestSchema>;
export const changeFilters: (payload: IGetVillageListRequestSchema) => TFiltersChanged = actionGenerator<
  EFilterActions.ChangeFilters,
  IGetVillageListRequestSchema
>(EFilterActions.ChangeFilters);

export type THeatingSourceTypeChanged = ITypedReduxAction<EFilterActions.ChangeHeatingSourceTypes, string[]>;
export const changeHeatingSourceType: (payload: string[]) => THeatingSourceTypeChanged = actionGenerator<
  EFilterActions.ChangeHeatingSourceTypes,
  string[]
>(EFilterActions.ChangeHeatingSourceTypes);

export type THeatingSourceTypesChanged = ITypedReduxAction<EFilterActions.ChangeHeatingSourceType, EHeatingSourceType>;
export const changeHeatingSourceTypeFilter: (payload: EHeatingSourceType) => THeatingSourceTypesChanged =
  actionGenerator<EFilterActions.ChangeHeatingSourceType, EHeatingSourceType>(EFilterActions.ChangeHeatingSourceType);

export type TNewObjectTypesChanged = ITypedReduxAction<EFilterActions.ChangeNewObjectTypes, string[]>;
export const changeNewObjectTypesFilter: (payload: string[]) => TNewObjectTypesChanged = actionGenerator<
  EFilterActions.ChangeNewObjectTypes,
  string[]
>(EFilterActions.ChangeNewObjectTypes);

export type TVillageClassesChanged = ITypedReduxAction<EFilterActions.ChangeVillageClasses, string[]>;
export const changeVillageClasses: (payload: string[]) => TVillageClassesChanged = actionGenerator<
  EFilterActions.ChangeVillageClasses,
  string[]
>(EFilterActions.ChangeVillageClasses);

export type TSaleStatusesChanged = ITypedReduxAction<EFilterActions.ChangeSaleStatuses, string[]>;
export const changeSaleStatuses: (payload: string[]) => TSaleStatusesChanged = actionGenerator<
  EFilterActions.ChangeSaleStatuses,
  string[]
>(EFilterActions.ChangeSaleStatuses);

export type EReadyStatusesChanged = ITypedReduxAction<EFilterActions.ChangeReadyStatuses, string[]>;
export const changeReadyStatus: (payload: string[]) => EReadyStatusesChanged = actionGenerator<
  EFilterActions.ChangeReadyStatuses,
  string[]
>(EFilterActions.ChangeReadyStatuses);

export type THouseMaterialsChanged = ITypedReduxAction<EFilterActions.ChangeHouseMaterials, string[]>;
export const changeHouseMaterials: (payload: string[]) => THouseMaterialsChanged = actionGenerator<
  EFilterActions.ChangeHouseMaterials,
  string[]
>(EFilterActions.ChangeHouseMaterials);

export type TOtherCommunicationsChanged = ITypedReduxAction<EFilterActions.ChangeOtherCommunications, string[]>;
export const changeOtherCommunications: (payload: string[]) => TOtherCommunicationsChanged = actionGenerator<
  EFilterActions.ChangeOtherCommunications,
  string[]
>(EFilterActions.ChangeOtherCommunications);

export type TNewObjectTypeChanged = ITypedReduxAction<EFilterActions.ChangeNewObjectType, IChangedFilterItem>;
export const changeNewObjectTypeFilter: (payload: IChangedFilterItem) => TNewObjectTypeChanged = actionGenerator<
  EFilterActions.ChangeNewObjectType,
  IChangedFilterItem
>(EFilterActions.ChangeNewObjectType);

export type TVillageClassChanged = ITypedReduxAction<EFilterActions.ChangeVillageClass, IChangedFilterItem>;
export const changeVillageClassFilter: (payload: IChangedFilterItem) => TVillageClassChanged = actionGenerator<
  EFilterActions.ChangeVillageClass,
  IChangedFilterItem
>(EFilterActions.ChangeVillageClass);

export type TFinishDateChanged = ITypedReduxAction<EFilterActions.ChangeFinishDate, string>;
export const changeFinishDateFilter: (payload: string) => TFinishDateChanged = actionGenerator<
  EFilterActions.ChangeFinishDate,
  string
>(EFilterActions.ChangeFinishDate);

export type TPriceRangeChanged = ITypedReduxAction<EFilterActions.ChangePriceRange, IRange>;
export const changePriceRangeFilter: (payload: IRange) => TPriceRangeChanged = actionGenerator<
  EFilterActions.ChangePriceRange,
  IRange
>(EFilterActions.ChangePriceRange);

export type TCommuteDistanceChanged = ITypedReduxAction<EFilterActions.ChangeCommuteDistance, IRange>;
export const changeCommuteDistance: (payload: IRange) => TCommuteDistanceChanged = actionGenerator<
  EFilterActions.ChangeCommuteDistance,
  IRange
>(EFilterActions.ChangeCommuteDistance);

export type ECommuteDistanceTypeChanged = ITypedReduxAction<EFilterActions.ChangeCommuteType, ECommuteDistanceType>;
export const changeCommuteDistanceType: (payload: ECommuteDistanceType) => ECommuteDistanceTypeChanged =
  actionGenerator<EFilterActions.ChangeCommuteType, ECommuteDistanceType>(EFilterActions.ChangeCommuteType);

export type TResetExtraFilters = ITypedReduxAction<EFilterActions.ResetExtraFilters, void>;
export const resetExtraFilters: () => TResetExtraFilters = actionGenerator<EFilterActions.ResetExtraFilters>(
  EFilterActions.ResetExtraFilters,
);

export type TRemoveFilters = ITypedReduxAction<EFilterActions.RemoveFilters, IGetVillageListRequestSchema>;
export const removeFilters: (payload: IGetVillageListRequestSchema) => TRemoveFilters = actionGenerator<
  EFilterActions.RemoveFilters,
  IGetVillageListRequestSchema
>(EFilterActions.RemoveFilters);

export type TRemoveLocationId = ITypedReduxAction<EFilterActions.RemoveLocationId, void>;
export const removeLocationId: () => TRemoveLocationId = actionGenerator<EFilterActions.RemoveLocationId>(
  EFilterActions.RemoveLocationId,
);

export type TBuilderIdRemoved = ITypedReduxAction<EFilterActions.RemoveBuilderId, void>;
export const removeBuilderIdFilter: () => TBuilderIdRemoved = actionGenerator<EFilterActions.RemoveBuilderId>(
  EFilterActions.RemoveBuilderId,
);

export type TBuilderIdAdded = ITypedReduxAction<EFilterActions.AddBuilderId, number>;
export const addBuilderIdFilter: (payload: number) => TBuilderIdAdded = actionGenerator<
  EFilterActions.AddBuilderId,
  number
>(EFilterActions.AddBuilderId);

export type TRoadFilterRemoved = ITypedReduxAction<EFilterActions.ChangeRoads, number>;
export const changeRoadFilter: (payload: number) => TRoadFilterRemoved = actionGenerator<
  EFilterActions.ChangeRoads,
  number
>(EFilterActions.ChangeRoads);

export type TStationsAdded = ITypedReduxAction<EFilterActions.AddStations, number[]>;
export const setStationFilter: (payload: number[]) => TStationsAdded = actionGenerator<
  EFilterActions.AddStations,
  number[]
>(EFilterActions.AddStations);

export type TStationDistanceChanged = ITypedReduxAction<EFilterActions.ChangeStationDistance, number>;
export const changeStationDistance: (payload?: number) => TStationDistanceChanged = actionGenerator<
  EFilterActions.ChangeStationDistance,
  number
>(EFilterActions.ChangeStationDistance);

export type TStationsChanged = ITypedReduxAction<EFilterActions.ChangeStations, number>;
export const changeStationFilter: (payload: number) => TStationsChanged = actionGenerator<
  EFilterActions.ChangeStations,
  number
>(EFilterActions.ChangeStations);

export type TRoadFilterAdded = ITypedReduxAction<EFilterActions.AddRoads, number[]>;
export const setRoadFilter: (payload: number[]) => TRoadFilterAdded = actionGenerator<
  EFilterActions.AddRoads,
  number[]
>(EFilterActions.AddRoads);

export type TRoadDistanceChanged = ITypedReduxAction<EFilterActions.ChangeRoadDistance, number>;
export const changeRoadDistance: (payload?: number) => TRoadDistanceChanged = actionGenerator<
  EFilterActions.ChangeRoadDistance,
  number
>(EFilterActions.ChangeRoadDistance);

export type TSaleStatusChanged = ITypedReduxAction<EFilterActions.ChangeSaleStatus, ESaleStatus>;
export const changeSaleStatusFilter: (payload: ESaleStatus) => TSaleStatusChanged = actionGenerator<
  EFilterActions.ChangeSaleStatus,
  ESaleStatus
>(EFilterActions.ChangeSaleStatus);

export type TReadyStatusChanged = ITypedReduxAction<EFilterActions.ChangeReadyStatus, EReadyStatus>;
export const changeReadyStatusFilter: (payload: EReadyStatus) => TReadyStatusChanged = actionGenerator<
  EFilterActions.ChangeReadyStatus,
  EReadyStatus
>(EFilterActions.ChangeReadyStatus);

export type TOtherCommunicationChanged = ITypedReduxAction<EFilterActions.ChangeCommunication, EOtherCommunications>;
export const changeOtherCommunicationFilter: (payload: EOtherCommunications) => TOtherCommunicationChanged =
  actionGenerator<EFilterActions.ChangeCommunication, EOtherCommunications>(EFilterActions.ChangeCommunication);

export type TAreaFromChanged = ITypedReduxAction<EFilterActions.ChangeAreaFrom, number>;
export const changeAreaFromFilter: (payload?: number) => TAreaFromChanged = actionGenerator<
  EFilterActions.ChangeAreaFrom,
  number
>(EFilterActions.ChangeAreaFrom);

export type TAreaToChanged = ITypedReduxAction<EFilterActions.ChangeAreaTo, number>;
export const changeAreaToFilter: (payload?: number) => TAreaToChanged = actionGenerator<
  EFilterActions.ChangeAreaTo,
  number
>(EFilterActions.ChangeAreaTo);

export type TFloorCountFromChanged = ITypedReduxAction<EFilterActions.ChangeFloorCountFrom, number>;
export const changeFloorCountFromFilter: (payload?: number) => TFloorCountFromChanged = actionGenerator<
  EFilterActions.ChangeFloorCountFrom,
  number
>(EFilterActions.ChangeFloorCountFrom);

export type TFloorCountToChanged = ITypedReduxAction<EFilterActions.ChangeFloorCountTo, number>;
export const changeFloorCountToFilter: (payload?: number) => TFloorCountToChanged = actionGenerator<
  EFilterActions.ChangeFloorCountTo,
  number
>(EFilterActions.ChangeFloorCountTo);

export type THouseMaterialChanged = ITypedReduxAction<EFilterActions.ChangeHouseMaterial, EHouseMaterialType>;
export const changeHouseMaterialFilter: (payload: EHouseMaterialType) => THouseMaterialChanged = actionGenerator<
  EFilterActions.ChangeHouseMaterial,
  EHouseMaterialType
>(EFilterActions.ChangeHouseMaterial);

export type TWcLocationChanged = ITypedReduxAction<EFilterActions.ChangeWcLocation, EWcLocationType | undefined>;
export const changeWcLocationTypeFilter: (payload: EWcLocationType | undefined) => TWcLocationChanged = actionGenerator<
  EFilterActions.ChangeWcLocation,
  EWcLocationType | undefined
>(EFilterActions.ChangeWcLocation);

export type TBlackFridayChanged = ITypedReduxAction<EFilterActions.ChangeBlackFridayFlag, boolean | undefined>;
export const changeBlackFridayTypeFilter: (payload: boolean | undefined) => TBlackFridayChanged = actionGenerator<
  EFilterActions.ChangeBlackFridayFlag,
  boolean | undefined
>(EFilterActions.ChangeBlackFridayFlag);

export type TPageChanged = ITypedReduxAction<EFilterActions.ChangePage, number>;
export const changePageFilter: (payload: number) => TPageChanged = actionGenerator<EFilterActions.ChangePage, number>(
  EFilterActions.ChangePage,
);

export interface IApplyLastFilters {
  type: 'IApplyLastFilters';
  filters: IGetVillageListRequestSchema;
}

export const rangeCreator =
  (minFn: Function, maxFn: Function) =>
  (min?: number, max?: number): IThunkActionCreator =>
  dispatch => {
    dispatch(minFn(min));
    dispatch(maxFn(max));
  };

export const changeFloorCountRange = rangeCreator(changeFloorCountFromFilter, changeFloorCountToFilter);
export const changeAreaRange = rangeCreator(changeAreaFromFilter, changeAreaToFilter);

export interface IFilterRegionChanged {
  isCitySelected?: boolean;
  type: 'FilterRegionChanged';
  region: ICity;
}

export interface IGetRegionByDomainFetched {
  type: 'GetRegionByDomainFetched';
  payload: IRegion;
}

export interface IHistoryState {
  filters: IGetVillageListRequestSchema;
}

export const changeQueryString =
  (filters?: IGetVillageListRequestSchema, addFiltersState?: boolean, reload?: boolean): IThunkActionCreator =>
  async (dispatch, getState, context) => {
    const { filters: defaultFilters } = getState();
    const newFilters = filters || defaultFilters;
    if (isClient()) {
      const path = window.location.pathname;
      const unknownQuery = getUnknownQuery(window.location.search, newFilters);
      const seoUrlPath = await getSeoUrlPath(context, path, newFilters, Boolean(addFiltersState));
      if (reload) {
        dispatch(fetchStarted());
        window.location.href = seoUrlPath;
      } else {
        const url = mergeQuery(seoUrlPath, unknownQuery);
        const stateArgs = [{ filters: newFilters }, document.title, url] as [IHistoryState, string, string | null];

        if (!window.history.state || !window.history.state.filters) {
          window.history.replaceState(...stateArgs);
        } else if (stringifyFilters(window.history.state.filters) !== stringifyFilters(newFilters)) {
          window.history.pushState(...stateArgs);
        }

        await dispatch(fetchSeoData());
        dispatch(fetchMarkedList(newFilters));
      }
    }
  };

export function changePage(
  page: number | undefined,
  shouldNotLoadData?: boolean,
  shouldUpdateQueryString: boolean = true,
): IThunkActionCreator {
  return (dispatch, getState) => {
    const state = getState();
    const {
      isFetching,
      filters,
      savedFilters,
      mobile: { isMobileVersion },
    } = state;

    if (isFetching) {
      return;
    }
    const p = page || filters.p || 1;

    const newFilters = { ...filters, p };

    if (!shouldNotLoadData) {
      dispatch(fetchVillageList(newFilters, isMobileVersion));
    }

    if (shouldUpdateQueryString) {
      dispatch(
        changeQueryString(
          {
            ...newFilters,
            /* на мобильной версии при переходе между страницами ссылка не должна меняться */
            p: isMobileVersion ? 1 : p,
          },
          !savedFilters.showAll,
        ),
      );
    }

    dispatch(changePageFilter(p));
  };
}

export function changeSorting(sorting: string): IThunkActionCreator {
  return (dispatch, getState) => {
    const state = getState();
    const { isFetching, filters } = state;

    if (isFetching) {
      return;
    }
    const p = 1;
    const newFilters = { ...filters, p, sorting: sorting as ESorting } as IGetVillageListRequestSchema;
    dispatch(fetchVillageList(newFilters));
    dispatch(changeQueryString(newFilters));
    dispatch(removeFilters(newFilters));
  };
}

export const geoUpdateCity =
  (region?: ICity, city?: ICity): IThunkActionCreator =>
  dispatch => {
    if (region) {
      dispatch(
        geoUpdateCityAction({
          city: city || region,
          region,
        }),
      );
    }
  };

export function changeRegion(region: ICity, shouldUpdateState: boolean, alwaysLoad?: boolean): IThunkActionCreator {
  return async (dispatch, getState, context) => {
    const {
      filters,
      geo,
      mobile: { isMobileVersion },
    } = getState();
    const isCitySelected = Boolean(region.parentId || region.regionId);

    if (alwaysLoad && isCitySelected) {
      dispatch(fetchRegionCities(region.id));

      return;
    }
    if (!isCitySelected) {
      const id = alwaysLoad ? region.id : region.shadowId;
      dispatch(fetchRegionCities(id || region.id));
    }
    if (!shouldUpdateState) {
      return;
    }

    if (!isMobileVersion) {
      dispatch(fetchStarted());

      const newFilters = {
        ...filters,
        locationId: region.id,
        locationType: ELocationType.Location,
        p: 1,
        regionId: region.regionId || region.id,
      } as IGetVillageListRequestSchema;
      window.location.href = await createRegionSeoUrl(context, geo.regions as IRegion[], newFilters, filters.regionId);
    } else {
      dispatch<IFilterRegionChanged>({
        isCitySelected,
        region,
        type: 'FilterRegionChanged',
      });
      dispatch(geoUpdateCity(region));
    }
  };
}

export function applyExtraFilters(shouldUpdateSubdomain?: boolean): IThunkActionCreator {
  return async (dispatch, getState, context) => {
    dispatch(fetchStarted());
    if (isClient()) {
      const { geo, filters } = getState();

      if (shouldUpdateSubdomain) {
        dispatch(changePage(1, true));
        window.location.href = await createRegionSeoUrl(
          context,
          (geo.regions as IRegion[]) || [],
          filters,
          filters.regionId,
        );
      } else {
        window.location.href = await getSeoUrlPath(context, window.location.pathname, { ...filters, p: 1 });
      }
    }
  };
}

export function removeSubroads(highwayId: number): IThunkActionCreator {
  return (dispatch, getState) => {
    const {
      roads: { currentRoads },
      filters: { road = [] },
    } = getState();

    currentRoads.forEach(({ id, directionId }) => {
      if (directionId === highwayId && road && road.includes(id)) {
        dispatch(changeRoadFilter(id));
      }
    });
  };
}
